// extracted by mini-css-extract-plugin
module.exports = {"ratio":".05208"};